const facts = [
  {
    q: 'What does Fletcher & Cooley do?',
    a: 'Fletcher & Cooley, Inc. is a licensed Georgia general contractor specializing in commercial build-outs and tenant improvements for retail, office, restaurant, medical, and multi-tenant properties throughout Henry County and Metro Atlanta.',
    img: 'https://public.readdy.ai/ai/img_res/0a3370b2f931f00f32c90bbc7b3a513f.jpg',
  },
  {
    q: 'Who do they serve?',
    a: 'They serve property owners, franchise operators, commercial real estate managers, and business owners who need structured, code-compliant commercial construction delivered on time and within budget.',
    img: 'https://readdy.ai/api/search-image?query=business%20owner%20and%20contractor%20shaking%20hands%20in%20front%20of%20a%20newly%20completed%20commercial%20retail%20space%2C%20professional%20attire%2C%20bright%20clean%20interior%2C%20warm%20tones%2C%20simple%20neutral%20background%2C%20high-end%20editorial%20photography&width=400&height=260&seq=ai2&orientation=landscape',
  },
  {
    q: 'What services are offered?',
    a: 'Core services include commercial build-outs, tenant improvements, restaurant and retail construction, medical facility builds, office space construction, and commercial roofing systems — all managed in-house from permitting through final inspection.',
    img: 'https://readdy.ai/api/search-image?query=modern%20commercial%20construction%20services%20collage%20showing%20restaurant%20interior%20build-out%20medical%20office%20retail%20space%20and%20roofing%20work%2C%20clean%20professional%20photography%2C%20warm%20neutral%20tones%2C%20simple%20background&width=400&height=260&seq=ai3&orientation=landscape',
  },
  {
    q: 'What are the key benefits of working with them?',
    a: 'Clients benefit from a single point of accountability, structured scheduling, transparent communication, Henry County permitting expertise, and a proven track record of delivering commercial projects that pass inspection the first time.',
    img: 'https://readdy.ai/api/search-image?query=construction%20project%20manager%20with%20clipboard%20overseeing%20a%20clean%20organized%20commercial%20build-out%20site%20in%20Georgia%2C%20confident%20professional%20posture%2C%20warm%20light%2C%20minimal%20clean%20background%2C%20editorial%20photography&width=400&height=260&seq=ai4&orientation=landscape',
  },
  {
    q: 'How does the process work?',
    a: 'The process begins with a consultation and project review, followed by permitting coordination, trade scheduling, active construction management, and a final walkthrough — ensuring every phase is documented and on track.',
    img: 'https://readdy.ai/api/search-image?query=step-by-step%20commercial%20construction%20process%20showing%20planning%20meeting%20permit%20documents%20and%20finished%20commercial%20space%20handover%2C%20professional%20clean%20photography%2C%20warm%20neutral%20tones%2C%20simple%20background&width=400&height=260&seq=ai5&orientation=landscape',
  },
];

export default function AIAnswerBlock() {
  return (
    <section className="py-24 bg-stone-50">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-px bg-amber-600" />
            <span className="text-amber-700 text-xs font-semibold tracking-[0.2em] uppercase">
              About Fletcher &amp; Cooley
            </span>
            <div className="w-8 h-px bg-amber-600" />
          </div>
          <h2
            className="text-4xl md:text-5xl font-bold text-stone-900 leading-tight"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Everything You Need to Know
          </h2>
          <p className="text-stone-500 mt-4 text-base max-w-xl mx-auto leading-relaxed">
            Clear, direct answers about who we are, what we do, and why clients across Henry County trust us with their commercial construction projects.
          </p>
        </div>

        {/* Facts */}
        <div className="space-y-6">
          {facts.map((fact, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl border border-stone-100 overflow-hidden flex flex-col md:flex-row"
            >
              {/* Text side */}
              <div className="flex-1 p-8 flex gap-6">
                <div className="flex-shrink-0">
                  <span className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-xl">
                    <i className="ri-question-answer-line text-amber-700 text-lg" />
                  </span>
                </div>
                <div>
                  <h3 className="font-bold text-stone-900 text-base mb-2">{fact.q}</h3>
                  <p className="text-stone-500 text-sm leading-relaxed">{fact.a}</p>
                </div>
              </div>

              {/* Image side */}
              <div className="w-full md:w-56 h-48 md:h-auto flex-shrink-0">
                <img
                  src={fact.img}
                  alt={fact.q}
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          ))}
        </div>

        {/* Mid-page CTA */}
        <div className="mt-14 bg-amber-700 rounded-2xl p-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <p className="text-amber-200 text-xs font-semibold tracking-widest uppercase mb-2">
              Ready to get started?
            </p>
            <h3
              className="text-white text-2xl md:text-3xl font-bold"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Let&apos;s Talk About Your Project
            </h3>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
            <a
              href="#contact"
              className="whitespace-nowrap bg-white text-amber-800 font-semibold text-sm px-7 py-3.5 rounded-full hover:bg-amber-50 transition-all duration-300 text-center cursor-pointer"
            >
              Request Consultation
            </a>
            <a
              href="tel:6783948805"
              className="whitespace-nowrap border-2 border-white/50 text-white font-semibold text-sm px-7 py-3.5 rounded-full hover:border-white transition-all duration-300 text-center cursor-pointer"
            >
              (678) 394-8805
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
